export default {
  // TODO: Update existing reducers & remove.
  authentication: {
    sent: false,
    completed: false,
    pending: false,
  },
};
